import Swiper from 'swiper/bundle';

const swiperPress = new Swiper('.press-slider', {
    slidesPerView: 'auto',
    spaceBetween: 18,
    navigation: {
        nextEl: '.press-slider-button-next',
        prevEl: '.press-slider-button-prev',
    }
});

function sliderPressAlignment() {
    let container = document.querySelector('.page-container');
    let sliderContainer = document.querySelector('.press__container');

    function leftM(from, to) {
        let style = window.getComputedStyle(from),
            marginLeftComputed = style.getPropertyValue('margin-left'),
            widthSlice = marginLeftComputed.slice(0, -2),
            wToNumber = Number(widthSlice),
            wrap = to;

        wrap.style.paddingLeft = `${wToNumber + 20}px`;
    }

    if(container && sliderContainer) {
        leftM(container, sliderContainer);
    }
}

window.addEventListener('DOMContentLoaded', () => { sliderPressAlignment(); });
window.addEventListener('resize', () => { sliderPressAlignment(); });

const swiperFood = new Swiper('.food-bank-slider', {
    slidesPerView: 'auto',
    initialSlide : 1,
    spaceBetween: 18,
    loop: true,
    centeredSlides: true,
});

const swiperSummary = new Swiper('.summary-slider', {
    slidesPerView: 3,
    navigation: {
        nextEl: '.reports__summary-slider-button-next',
        prevEl: '.reports__summary-slider-button-prev',
    },
    breakpoints: {
        768: { spaceBetween: 25 },
        890: { spaceBetween: 55 }
    }
});

// Companies Slider
$(window).on("load resize scroll",() => {
    let scrolled, scrolledPrt, blockId;
    const slideBlocks = $('.js-block');
    const slideImgs = $('.js-img');
    const slideDots = $('.js-dot');
    const scrollImageStart = slideBlocks.height() / 100 * 30

    slideBlocks.each(function() {
        // main
        scrolled = window.scrollY + window.innerHeight - $(this).offset().top + scrollImageStart;
        scrolledPrt = Math.round(scrolled * 100 / slideBlocks.height());
        blockId = $(this).attr("data-id");

        if(scrolled < 0) {
            scrolled = 0;
        }

        slideImgs.each(function() {
            if($(this).attr("data-id") === blockId) {
                $(this).css({
                    width: `${scrolledPrt}%`,
                    height: `${scrolledPrt}%`
                })
            }
        });

        // dots
        if(window.scrollY + window.innerHeight + 10 > $(this).offset().top + $('.js-block').height() / 2) {
            slideDots.each(function() {
                if($(this).attr("data-id") === blockId) {
                    slideDots.removeClass('active');
                    $(this).addClass('active');
                }
            });
        } else {
            slideDots.each(function() {
                if($(this).attr("data-id") === blockId) {
                    $(this).removeClass('active');
                }
            });
        }
    });
});

// companies slider dots
$(".js-dot").click(function(e) {
    e.preventDefault();
    let stickyHeaderHeight = 0;
    let dotId = $(this).attr("data-id");
    $('html,body').animate({scrollTop: $(`.js-block[data-id=${dotId}]`).offset().top - stickyHeaderHeight},'slow');
});
